import { getBackendImage } from '@/utils/getBackendImage';
import { parseText } from '@/utils/parseText';
import cn from 'classnames';
import { ReactNode } from 'react';
import { Breadcrumbs, BreadcrumbsVariant } from '../Breadcrumbs';
import { Shadow } from '../Shadow';
import styles from './BannerStatic.module.scss';

type BannerStaticProps = {
  className?: string;
  title?: string;
  image: string;
  mobileImage?: string;
  tabletImage?: string;
  content?: ReactNode;
  absolute?: boolean;
  heading?: string;
  breadcrumbs?: { link: string; text: string }[];
  breadcrumbsVariant?: BreadcrumbsVariant;
  titleColor?: string;
};

export function BannerStatic({
  className,
  title,
  image,
  mobileImage,
  tabletImage,
  content,
  absolute,
  heading,
  breadcrumbs,
  breadcrumbsVariant = BreadcrumbsVariant.Light,
  titleColor,
}: BannerStaticProps) {
  const wrapperClassName = cn(
    styles.container,
    {
      [styles.absolute]: absolute,
    },
    className,
  );
  const bgImage = getBackendImage(image);
  const bgImageTablet = getBackendImage(tabletImage || image);
  const bgImageMobile = getBackendImage(mobileImage || image);

  return (
    <div className={wrapperClassName}>
      {breadcrumbs ? (
        <Breadcrumbs
          routes={breadcrumbs}
          className={styles.breadcrumbs}
          variant={breadcrumbsVariant}
        />
      ) : (
        <div />
      )}
      <div className={styles.empty} />
      <img src={bgImage} alt={title} className={styles.img} />
      <img src={bgImageTablet} alt={title} className={styles.imgTablet} />
      <img src={bgImageMobile} alt={title} className={styles.imgMobile} />
      {heading && !content && (
        <h1 className={styles.heading} style={{ color: titleColor }}>
          {parseText(heading)}
        </h1>
      )}
      {title && !content && <span className={styles.text}>{title}</span>}
      {content && content}
      <Shadow opacity={0.04} />
    </div>
  );
}
